export function resolveMultilingualText(
  textsMapValue: string,
  settingsValue: string,
  isFixMultilingualTextInSFEnabled: boolean,
  isPrimaryLanguage: boolean
): string {
  const preferTextsMapFirst = isFixMultilingualTextInSFEnabled && !isPrimaryLanguage;
  return preferTextsMapFirst ? textsMapValue || settingsValue : settingsValue || textsMapValue;
}
